import { render } from "./fullscreenIframePlayer.vue?vue&type=template&id=4735266c"
import script from "./fullscreenIframePlayer.vue?vue&type=script&lang=js"
export * from "./fullscreenIframePlayer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__